import { createContext, useContext } from 'react';

export const BottlerApolloContext = createContext({});

export const useBottlerContext = () => useContext(BottlerApolloContext);
